import * as React from 'react';
import { useIntl } from 'react-intl';
import PermissionsService from '../../../Services/PermissionsService';
import ConfirmDialog from '../../ConfirmDialog';
import useAnalytics from '../../../hooks/useAnalytics';
import { getTableName } from '../CmdTableService';

interface DetailActionProps {
  id: number;
  tableName: string;
  onClickCallback: (id: number, customerId?: number | number[]) => void;
  customerId?: number | number[];
  showConfirmDialog?: boolean;
  confirmDialogMessage?: string;
}

function DeleteAction(props: DetailActionProps) {
  const { formatMessage: f } = useIntl();
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = React.useState<boolean>(false);
  const { trackEvent } = useAnalytics();

  const isDisabled = !PermissionsService.hasAccess(
    props.tableName,
    ['delete'],
    props.customerId || null
  );

  const handleOnClick = () => {
    trackEvent([`table ${getTableName(props.tableName)}`, 'click', 'Delete action']);
    if (props.showConfirmDialog) {
      setIsConfirmDialogOpen(true);
    } else {
      props.onClickCallback(props.id, props.customerId);
    }
  };

  const handleCancel = () => {
    setIsConfirmDialogOpen(false);
    trackEvent([`table ${getTableName(props.tableName)}`, 'click', 'Cancel delete action']);
  };

  const handleConfirm = () => {
    props.onClickCallback(props.id, props.customerId);
    setIsConfirmDialogOpen(false);
    trackEvent([`table ${getTableName(props.tableName)}`, 'click', 'Confirm delete action']);
  };

  return (
    <>
      <button
        type="button"
        title={f({ id: 'table.deleteBtn' })}
        data-cy="table-detail-action"
        className="cmd-table-text-gray w-full"
        data-type="detail"
        data-id={props.id}
        // style={{ padding: '10px 25px', margin: '-10px -25px', textAlign: 'center' }}
        style={isDisabled ? { color: '#ccc' } : undefined}
        onClick={handleOnClick}
        disabled={isDisabled}
      >
        <i className="cmd-icon cmd-icon-bin fs-4" />
        <span className="sr-only">{f({ id: 'table.deleteBtn' })}</span>
      </button>
      {isConfirmDialogOpen && (
        <ConfirmDialog
          title={f({
            id: 'table.confirm.dialog.remove.title',
          })}
          cancelCallback={handleCancel}
          continueCallback={handleConfirm}
          cancelButtonTitle={f({
            id: 'form.cancel',
          })}
          continueButtonTitle={f({
            id: 'table.deleteBtn',
          })}
        >
          {props.confirmDialogMessage || f({ id: 'table.confirm.dialog.remove.message' })}
        </ConfirmDialog>
      )}
    </>
  );
}

export default DeleteAction;
